/**
 * Whether Teams has suspended this tab: it keeps the iframe alive but hidden, and no Teams SDK call
 * is allowed until it resumes. Plain state with no SDK import, so the sign-in core can respect it
 * without depending on the Teams lifecycle module that sets it.
 */
let suspended = false;
let resumeWaiters: Array<() => void> = [];

/** True between Teams' suspend and resume callbacks. */
export function isTeamsAppSuspended(): boolean {
  return suspended;
}

/** Records a suspend or a resume; a resume releases everything waiting in {@link whenTeamsResumed}. */
export function setTeamsAppSuspended(next: boolean): void {
  suspended = next;
  if (next) return;
  const waiters = resumeWaiters;
  resumeWaiters = [];
  for (const release of waiters) release();
}

/** Resolves once the tab is awake; at once when it is not suspended. */
export function whenTeamsResumed(): Promise<void> {
  if (!suspended) return Promise.resolve();
  return new Promise<void>((resolve) => {
    resumeWaiters.push(resolve);
  });
}

/** Test-only: back to awake with nobody waiting. */
export function _resetTeamsSuspensionForTests(): void {
  suspended = false;
  resumeWaiters = [];
}
